import { render, staticRenderFns } from "./ClientUserAdminSUP.vue?vue&type=template&id=477d9020&scoped=true"
import script from "./ClientUserAdminSUP.vue?vue&type=script&lang=js"
export * from "./ClientUserAdminSUP.vue?vue&type=script&lang=js"
import style0 from "./ClientUserAdminSUP.vue?vue&type=style&index=0&id=477d9020&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477d9020",
  null
  
)

export default component.exports